import TApplicationInviteUserForm from './index.vue';

TApplicationInviteUserForm.install = app => {
  app.component(TApplicationInviteUserForm.name, TApplicationInviteUserForm);
};

export default TApplicationInviteUserForm;
